export type SubmissionResultType = 'success' | 'notFound' | 'badRequest' | 'technical' | 'bad_credentials' | null;

export const TMS_LABEL_BY_RESULT: Record<Exclude<SubmissionResultType, null>, string> = {
    success: 'succes',
    notFound: 'erreur_not_found',
    badRequest: 'erreur_bad_request',
    technical: 'erreur_technical',
    bad_credentials: 'erreur_bad_credentials'
};

const PHONE_NUMBER_PATTERN = /^0[1-9]\d{8}$/;
const CUSTOMER_PID_PATTERN = /^\d{10}$/;

export function getPreviousView(activeView: string): string {
    if (activeView === 'form') {
        return 'intro';
    }
    if (activeView === 'info') {
        return 'form';
    }
    return activeView;
}

export function isMandatoryValueDefined(value: string): boolean {
    return value != null && value.trim() !== "";
}

export function validateDiscountFormValues(phoneLineValue: string, customerCodeValue: string) {
    let isValid = true;
    let phoneLineErrorMessage = "";
    let customerCodeErrorMessage = "";

    if (!isMandatoryValueDefined(phoneLineValue)) {
        phoneLineErrorMessage = "Ce champ est obligatoire.";
        isValid = false;
    } else if (!PHONE_NUMBER_PATTERN.test(phoneLineValue)) {
        phoneLineErrorMessage = "Le format doit être : 10 chiffres commençant par 01 à 09";
        isValid = false;
    }

    if (!isMandatoryValueDefined(customerCodeValue)) {
        customerCodeErrorMessage = "Ce champ est obligatoire.";
        isValid = false;
    } else if (!CUSTOMER_PID_PATTERN.test(customerCodeValue)) {
        customerCodeErrorMessage = "Le format doit être : 10 chiffres";
        isValid = false;
    }

    return {
        isValid,
        phoneLineErrorMessage,
        customerCodeErrorMessage
    };
}
